/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PdpmEstimatorComponentReferenceMeta } from './PdpmEstimatorComponentReferenceMeta';
import {
    PdpmEstimatorComponentReferenceMetaFromJSON,
    PdpmEstimatorComponentReferenceMetaFromJSONTyped,
    PdpmEstimatorComponentReferenceMetaToJSON,
    PdpmEstimatorComponentReferenceMetaToJSONTyped,
} from './PdpmEstimatorComponentReferenceMeta';
import type { PdpmEstimatorFieldReferenceMeta } from './PdpmEstimatorFieldReferenceMeta';
import {
    PdpmEstimatorFieldReferenceMetaFromJSON,
    PdpmEstimatorFieldReferenceMetaFromJSONTyped,
    PdpmEstimatorFieldReferenceMetaToJSON,
    PdpmEstimatorFieldReferenceMetaToJSONTyped,
} from './PdpmEstimatorFieldReferenceMeta';
import type { AiSummaryCardReferenceMeta } from './AiSummaryCardReferenceMeta';
import {
    AiSummaryCardReferenceMetaFromJSON,
    AiSummaryCardReferenceMetaFromJSONTyped,
    AiSummaryCardReferenceMetaToJSON,
    AiSummaryCardReferenceMetaToJSONTyped,
} from './AiSummaryCardReferenceMeta';

/**
 * 
 * @export
 * @interface LeadCommentReferenceMeta
 */
export interface LeadCommentReferenceMeta {
    /**
     * 
     */
    pdpm_estimator_field?: PdpmEstimatorFieldReferenceMeta;
    /**
     * 
     */
    pdpm_estimator_component?: PdpmEstimatorComponentReferenceMeta;
    /**
     * 
     */
    ai_summary_card?: AiSummaryCardReferenceMeta;
}

/**
 * Check if a given object implements the LeadCommentReferenceMeta interface.
 */
export function instanceOfLeadCommentReferenceMeta(value: object): value is LeadCommentReferenceMeta {
    return true;
}

export function LeadCommentReferenceMetaFromJSON(json: any): LeadCommentReferenceMeta {
    return LeadCommentReferenceMetaFromJSONTyped(json, false);
}

export function LeadCommentReferenceMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadCommentReferenceMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'pdpm_estimator_field': json['pdpm_estimator_field'] == null ? undefined : PdpmEstimatorFieldReferenceMetaFromJSON(json['pdpm_estimator_field']),
        'pdpm_estimator_component': json['pdpm_estimator_component'] == null ? undefined : PdpmEstimatorComponentReferenceMetaFromJSON(json['pdpm_estimator_component']),
        'ai_summary_card': json['ai_summary_card'] == null ? undefined : AiSummaryCardReferenceMetaFromJSON(json['ai_summary_card']),
    };
}

export function LeadCommentReferenceMetaToJSON(json: any): LeadCommentReferenceMeta {
    return LeadCommentReferenceMetaToJSONTyped(json, false);
}

export function LeadCommentReferenceMetaToJSONTyped(value?: LeadCommentReferenceMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pdpm_estimator_field': PdpmEstimatorFieldReferenceMetaToJSON(value['pdpm_estimator_field']),
        'pdpm_estimator_component': PdpmEstimatorComponentReferenceMetaToJSON(value['pdpm_estimator_component']),
        'ai_summary_card': AiSummaryCardReferenceMetaToJSON(value['ai_summary_card']),
    };
}

